module.exports = __webpack_public_path__ + "static/media/a1.467383db.jpg";